const styles = theme => {
  return ({
    root: {
      flexGrow: 1,
      width: '100%',
      maxWidth: '100%',
      boxSizing: 'border-box',
      margin: '0 auto',
      overflowX: 'hidden',
      padding: '24px',
      [theme.breakpoints.up('lg')]: {
        width: '70%',
      },
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: theme.spacing.unit * 2,
    },
    introduction: {
      marginTop: 0,
      marginBottom: theme.spacing.unit * 3,
      maxWidth: 760,
    },
    defaultBadge: {
      display: 'inline-block',
      padding: '2px 8px',
      borderRadius: '4px',
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 'bold',
    },
    actions: {
      display: 'flex',
      gap: '8px',
      minWidth: '380px',
      flexWrap: 'nowrap',
      '& button': {
        flex: '0 0 auto',
        whiteSpace: 'nowrap',
      },
    },
    tableContainer: {
      border: '0.5px solid var(--border-color)',
      borderRadius: 'var(--radius)',
      overflow: 'auto',
    },
    table: {
      width: '100%',
      border: 0,
    },
    emptyState: {
      textAlign: 'center',
      padding: theme.spacing.unit * 4,
      color: theme.palette.text.secondary,
    },
  })
}

export default styles
